import React from 'react';
import Footer from '../components/Footer';
import useScrollReveal from '../components/useScrollReveal';
import './Veil.css';
import veronicaImg from '../assets/Saint_Veronica_With_Veil.jpg';
import holyFace from '../assets/holy-face.png';

function Reveal({ children, delay = '0s' }) {
  const ref = useScrollReveal();
  return (
      <div ref={ref} className="reveal-block" style={{ '--reveal-delay': delay }}>
        {children}
      </div>
  );
}

export default function Veil() {
  return (
      <div className="page page-dark">
        <section
            className="veil-hero"
            style={{
              backgroundImage: `url(${holyFace})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 37%',
            }}
        >
          <div className="veil-hero__glow"/>
          <div className="veil-hero__content fade-up">
            <span className="section-label light">Sacred Tradition</span>
            <h1>The Veil of Veronica</h1>
            <p><em>Vera Icona</em> — True Image</p>
          </div>
        </section>

        <div className="section-inner">
          <div className="veil-intro">
            <Reveal>
              <h2>An Act of Compassion</h2>
            </Reveal>
            <div className="veil-cols">
              <Reveal delay="0.1s">
                <p>
                  According to Catholic tradition, as Jesus made His way to Calvary,
                  a woman named Veronica wiped His face with her veil. His image was
                  miraculously left imprinted upon it, and her simple act of mercy offered,
                  amidst a hostile crowd, became one of the most beloved moments of the Passion.
                </p>
              </Reveal>
              <Reveal delay="0.2s">
                <p>
                  The name "Veronica" itself may derive from the Latin <em>vera icona</em> —
                  meaning "true image." Veronica's Veil has been kept and venerated at St.
                  Peter's Basilica in Rome since at least the 12th century, and was once one
                  of the most celebrated pilgrim destinations in Christendom.
                </p>
              </Reveal>
            </div>
          </div>

          <Reveal delay="0.15s">
            <Reveal delay="0.15s">
              <div className="veil-painting-wrap">
                <img
                    src={veronicaImg}
                    alt="Saint Veronica with the Veil"
                    className="veil-painting"
                />
              </div>
            </Reveal>
          </Reveal>

          <Reveal delay="0.1s">
            <blockquote className="scripture">
              <p>"Your Face, Lord, do I seek. Hide not Your Face from me."</p>
              <cite>— Psalm 27:8–9</cite>
            </blockquote>
          </Reveal>

          {/* Stations of the Cross note */}
          <Reveal delay="0.15s">
            <div className="station-box">
              <span className="station-box__num">VI</span>
              <div className="station-box__text">
                <h3>The Sixth Station</h3>
                <p>
                  The sixth Station of the Cross commemorates Veronica's act of compassion,
                  <em>"Veronica Wipes the Face of Jesus."</em> Across the
                  centuries this station has moved countless souls to imitate her courage and
                  tenderness in seeking the Face of Christ in His suffering.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Timeline */}
          <Reveal>
            <h2 style={{marginTop: '4rem'}}>Through the Centuries</h2>
          </Reveal>
          <div className="timeline">
            {[
              {year: '~33 AD', text: 'The Via Dolorosa — Veronica wipes the face of Jesus on the way to Calvary.'},
              {
                year: '1199 AD',
                text: "The Veil of Veronica is recorded in the keeping of St. Peter's Basilica in Rome."
              },
              {
                year: '1297 AD',
                text: 'Pope Boniface VIII formally establishes an indulgence for pilgrims who venerate the Veil.'
              },
              {
                year: '1500s',
                text: 'The Veil rises to prominence as one of the most sought-after relics in all of Christendom, attracting pilgrims from far and wide.'
              },
              {
                year: 'Today',
                text: 'The Stations of the Cross and devotion to The Holy Face sustain and perpetuate Veronica\u2019s memory throughout the world.'
              },
            ].map(({year, text}, i) => (
                <Reveal key={year} delay={`${i * 0.08}s`}>
                  <div className="timeline__item">
                    <span className="timeline__year">{year}</span>
                    <p className="timeline__text">{text}</p>
                  </div>
                </Reveal>
            ))}
          </div>
        </div>

        <Footer/>
      </div>
  );
}